module.exports = __webpack_public_path__ + "img/collection-engagementRingsFastDelivery@2x.0ec1188.jpg";